import React from 'react'
import { Routes, Route } from 'react-router-dom'
import RequireEditorialCommittee from '../../components/RequireEditorialCommittee'
import TextbookList from './TextbookList'
import TextbookEdit from './TextbookEdit'
import TextbookReview from './TextbookReview'
import ChapterReview from './ChapterReview'
import TextbookWriting from './TextbookWriting'
import TextbookWritingChatPage from './TextbookWritingChatPage'
import TaskList from './TaskList'
import TaskDetail from './TaskDetail'

const Textbook: React.FC = () => {
  return (
    <Routes>
      <Route index element={<TextbookList />} />
      <Route
        path="writing"
        element={
          <RequireEditorialCommittee>
            <TextbookWriting />
          </RequireEditorialCommittee>
        }
      />
      <Route
        path="writing/chat"
        element={
          <RequireEditorialCommittee>
            <TextbookWritingChatPage />
          </RequireEditorialCommittee>
        }
      />
      <Route path=":id/edit" element={<TextbookEdit />} />
      <Route path=":id/review" element={<TextbookReview />} />
      <Route path="chapters/:chapterId/review" element={<ChapterReview />} />
      <Route
        path="tasks"
        element={
          <RequireEditorialCommittee>
            <TaskList />
          </RequireEditorialCommittee>
        }
      />
      <Route
        path="tasks/:taskId"
        element={
          <RequireEditorialCommittee>
            <TaskDetail />
          </RequireEditorialCommittee>
        }
      />
    </Routes>
  )
}

export default Textbook

